import React, { useMemo, useState, useEffect } from 'react'
import './digital-vault-operational-report.css'
import { Container, Grid } from '@material-ui/core'
import GridSelectionHLPure from '../../pures/GridSelectionHLPure/gridSelectionHL.pure';
import { ButtonHLPure, SimpleLoading, InputFileHLPure, DataPickerHLPure, DialogSystemGLPure, LabelHLPure, LabelModalPure } from '../../pures';
import RenovationDialog from './components/renovation-dialog'
import { DigitalVaultDocumentService, LocalStorageService } from '../../../services';
import PdfReader from "../../pures/adobePfdReader/PdfReader"
import moment from "moment"
import { PieGraphCustomLabel } from '../digital-vault-reports/graphs';
import { VictoryLabel, VictoryPie } from 'victory';
import dashboardColors from '../digital-vault-reports/dashboardColors';
import { useMediaQuery } from "@material-ui/core";

const HeaderColumns = (props) => {
    return (
        <span className={(props.title === props.t("digitalVaultOpereationalReportView.about.grid.2.title.1")) ? "grid-header-one" : "grid-headers"}>{props.title}</span>
    );

}

const TextCell = (props) => {
    const {
        dataItem,
        col
    } = props;

    const data = [dataItem.name, dataItem.companyName, Math.abs(dataItem.days)];

    return (
        <td>
            <span className={(col === 1) ? "grid-cell-titles-margin-left" : "grid-cell-subtitles"}>
                {data[col - 1]}
            </span>
        </td>
    )
}

const StatusCell = (props) => {
    const {
        dataItem,
        col
    } = props;

    let color = "gray"

    if (dataItem.days < 30) color = "orange"
    else if (dataItem.days < 90) color = "yellow"
    else color = "green"

    return <td className={`digitalVaultOperationalReportView-col${col}`}>
        <div>
            <div className={`digitalVaultOperationalReportView-status ${color}`}></div>
        </div>
    </td>
}

const DigitalVaultOpereationalReportView = (props) => {
    let {
        isLoading,
        isUser,
        documentsToExpire,
        expiredDocuments,
        setSelectedDocumentId,
        totalAlerts,
        t
    } = props;

    const is1600 = useMediaQuery("(max-width:1600px)");
    const is820 = useMediaQuery("(max-width:820px)");

    const pdfToBase64 = async (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });

    const nextDocToExpire = useMemo(() => {
        if (documentsToExpire.length) return documentsToExpire.reduce((prev, current) => (prev.days < current.days) ? prev : current)
        return null
    }, [documentsToExpire]);

    useEffect(() => {
        if (documentsToExpire.length) {
            let copyData = documentsToExpire.reduce((prev, current) => (prev.days < current.days) ? prev : current)
            let dateToValidate = new Date(copyData.validation)
            let newDate = new Date(dateToValidate.setDate(dateToValidate.getDate() + 1))
            newDate.setDate(newDate.getDate() + 1)
            setDocumentData({ ...documentData, documentId: copyData.id, date: newDate, companyId: copyData.companId })
            setDateValue(newDate)
        }
    }, [documentsToExpire])

    const [showDialog, setShowDialog] = useState(false)
    const [dateValue, setDateValue] = useState(new Date())
    const [documentData, setDocumentData] = useState({ file: {}, date: new Date(), documentId: 0, companyId: "" })
    const [selectedFileName, setSelectedFileName] = useState("")
    const [selectedFileBase64, setSelectedFileBase64] = useState("")
    const [modalStates, setModalStates] = useState(
        {
            showLoadingRequesting: false,
            showCompletedRequesting: false,
            showErrorRequesting: false,
            showWarningRequesting: false,
            message: "",
            toggleLoadingRequesting: () => {
                setModalStates({ ...modalStates, showLoadingRequesting: false })
            },
            toggleCompletedRequesting: () => {
                setModalStates({ ...modalStates, showCompletedRequesting: false })
            },
            toggleErrorRequesting: () => {
                setModalStates({ ...modalStates, showErrorRequesting: false })
            },
            toggleWarningRequesting: () => {
                setModalStates({ ...modalStates, showErrorRequesting: false })
            }
        }
    )
    const pdf = useMemo(() => <PdfReader className="pdfReader" file={selectedFileBase64} isFile src={`data:application/pdf;base64,${selectedFileBase64}`}  ></PdfReader>, [selectedFileBase64])


    if (isLoading) return <SimpleLoading />

    const renewDocument = async () => {
        if (!selectedFileBase64) return setModalStates({ ...modalStates, showWarningRequesting: true, message: "Ingrese algún documento para renovar" }), setTimeout(() => {
            modalStates.toggleWarningRequesting()
            setModalStates({ ...modalStates, message: "" })
        }, 2000)
        setModalStates({ ...modalStates, showLoadingRequesting: true })
        const digitalVaultDocumentService = new DigitalVaultDocumentService(process.env.REACT_APP_MIFIRMA_API)
        const localStorageService = new LocalStorageService()
        const token = localStorageService.getLocalStorageItem("token").idToken
        try {
            const renewedDocumentData = new FormData()
            renewedDocumentData.append("documentId", documentData.documentId)
            renewedDocumentData.append("companyId", documentData.companyId)
            renewedDocumentData.append("renewedDate", moment(dateValue).format("YYYY-MM-DD"))
            renewedDocumentData.append("renewedDocument", documentData.file)

            const renewedDocument = await digitalVaultDocumentService.renewDocument(renewedDocumentData, token)
            if (renewedDocument.statusCode !== 200) {
                setModalStates({ ...modalStates, showLoadingRequesting: false, showErrorRequesting: true })
                setTimeout(() => {
                    setModalStates({ ...modalStates, showErrorRequesting: false })
                }, 2000)
            }
            setModalStates({ ...modalStates, showLoadingRequesting: false, showCompletedRequesting: true })
            setTimeout(() => {
                setModalStates({ ...modalStates, showCompletedRequesting: false })
                closeDialog()
            }, 2000);
        } catch (e) {
            setModalStates({ ...modalStates, showLoadingRequesting: false, showErrorRequesting: true })
            setTimeout(() => {
                setModalStates({ ...modalStates, showErrorRequesting: false })
                closeDialog()
            }, 2000)
        }
    }

    // Grid
    const AllHeadersColumns = (props) => <HeaderColumns {...props} t={t} />
    const DocumentsCellOne = (props) => <TextCell {...props} col={1} />
    const DocumentsCellTwo = (props) => <TextCell {...props} col={2} />
    const DocumentsCellThree = (props) => <TextCell {...props} col={3} />
    const DocumentsCellFour = (props) => <StatusCell {...props} col={4} />

    const handleFile = async (e) => {
        let pdf = await pdfToBase64(e.target.files[0])
        let pdfBase64 = pdf.split(",")[1];
        setDocumentData({ ...documentData, file: e.target.files[0] })
        setSelectedFileBase64(pdfBase64)
        setSelectedFileName(e.target.files[0].name)
    }

    const closeDialog = () => {
        setShowDialog(false)
        setDocumentData({ ...documentData, file: {} })
        setSelectedFileBase64("")
        setSelectedFileName("")
    }

    const deleteFile = () => {
        setDocumentData({ ...documentData, file: {} })
        setSelectedFileBase64("")
        setSelectedFileName("")
    }

    let widthColumnFive = '55px'

    if (is1600) widthColumnFive = '25px'

    return (
        <Container disableGutters className='digitalVaultOperationalReportView'>
            <Grid container spacing={3}>
                {nextDocToExpire &&
                    <Grid item xs={12} md={4} lg={3}>
                        <div className='digitalVaultReportsView-card nextToExpire'>
                            <LabelHLPure text={`${t("digitalVaultOpereationalReportView.limit.date")} ${nextDocToExpire.validation}`} fontSize={'16px'} />
                            <span class="k-icon k-font-icon k-i-calendar"></span>
                            <LabelHLPure text={t("digitalVaultOpereationalReportView.document.expired")} fontSize={'16px'} />
                            <LabelHLPure text={nextDocToExpire.name} fontSize={'16px'} />
                            <LabelHLPure text={`${nextDocToExpire.days} ${t("digitalVaultOpereationalReportView.days")}`} fontSize={'30px'} />
                            <ButtonHLPure
                                nameBtn={t("button.renew")}
                                primary
                                onClickBtn={() => setShowDialog(true)}
                            />
                        </div>
                        {showDialog &&
                            <RenovationDialog
                                title={t("digitalVaultOpereationalReportView.modal.title")}
                                description={t("digitalVaultOpereationalReportView.modal.description")}
                                saveBtn={t("button.renew")}
                                canelBtn={t("button.cancel")}
                                width={1000}
                                height={650}
                                heightBody={400}
                                handleFile={handleFile}
                                handleDeleteFile={() => deleteFile()}
                                cancel={() => closeDialog()}
                                handleSubmitProfile={() => renewDocument()}
                                bottomChildren={
                                    <div style=
                                        {
                                            {
                                                display: "flex",
                                                alignItems: "center"
                                            }
                                        }
                                    >
                                        <LabelModalPure label={t("digitalVaultOpereationalReportView.modal.new.date")} />
                                        <DataPickerHLPure
                                            valueDate={dateValue}
                                            limitDate={documentData.date}
                                            handleChangeDate={(e) => setDateValue(e.target.value)}
                                        />
                                    </div>
                                }
                            // loadingComponent={isLoadingModalPdf}
                            >
                                <div className="contractingRegistrationDocumentsView-card">
                                    <Grid container lg={12} md={12} sm={12} es={12}>
                                        <Grid
                                            item
                                            lg={12}
                                            md={12}
                                            sm={12}
                                            es={12}
                                            className="container-btns-pdf"
                                        >
                                            <InputFileHLPure
                                                messageBtn={t("digitalVaultOpereationalReportView.modal.btn.upload")}
                                                flex
                                                acceptFile={"application/pdf"}
                                                selectedFile={selectedFileBase64}
                                                selectedFileName={selectedFileName}
                                                // errorFile={errorFile}
                                                handleFile={e => handleFile(e)}
                                                handleDeleteFile={deleteFile}
                                                tooltipShow
                                                positionTooltip={'right'}
                                                titleTooltip={t("digitalVaultOpereationalReportView.modal.description")}
                                                descriptionTooltip={t("digitalVaultOpereationalReportView.modal.tooltip.description")}
                                                // labelActive={false}
                                                informationIcon
                                            />
                                        </Grid>
                                        {/*View document*/}
                                        <Grid container lg={12} md={12} sm={12} es={12}>
                                            {selectedFileBase64 && (
                                                <Grid item lg={12} md={12} sm={12} es={12}>
                                                    {pdf}
                                                </Grid>
                                            )}
                                        </Grid>
                                    </Grid>
                                </div>
                            </RenovationDialog>
                        }
                    </Grid>
                }
                <Grid item xs={12} md={nextDocToExpire ? 8 : undefined} lg={nextDocToExpire ? 9 : undefined} className="dashboard-item">
                    <div className="digitalVaultReportsView-card graph-container">
                        <div className="graph pie">
                            <LabelHLPure text={t("digitalVaultOpereationalReportView.number.alerts")} fontSize={'18px'} />
                            {isUser && <LabelHLPure text={t("digitalVaultOpereationalReportView.only.companies.for.user")} />}
                            <svg width={"100%"} height={"100%"} viewBox={`0 0 400 300`}>
                                <VictoryLabel
                                    textAnchor="middle"
                                    style={{ fontSize: 20 }}
                                    x={200} y={150}
                                    text={`${t("digitalVaultOpereationalReportView.total")}: ${totalAlerts.reduce((accumulator, currentValue) => {
                                        return accumulator + currentValue.alerts
                                    }, 0)}`}
                                />
                                <VictoryPie
                                    data={totalAlerts}
                                    standalone={false}
                                    x="companyName"
                                    y="alerts"
                                    padding={40}
                                    height={290}
                                    animate={{
                                        duration: 100
                                    }}
                                    padAngle={2}
                                    innerRadius={75}
                                    colorScale={dashboardColors}

                                    style={{ labels: { fill: "white", fontFamily: 'Quicksand' } }}
                                    labelRadius={120}
                                    labels={({ datum }) => [`${datum.alerts}`, `${t("digitalVaultOpereationalReportView.alerts")}`]}
                                    labelComponent={<PieGraphCustomLabel width={400} height={290} />}
                                />
                            </svg>
                        </div>
                    </div>
                </Grid>
                <Grid item sm={12} md={6}>
                    <div className='digitalVaultReportsView-card'>
                        <h4 className='digitalVaultReportsView-card-title toExpire'>{t("digitalVaultOpereationalReportView.about.to.expire")}</h4>
                        <GridSelectionHLPure
                            skip={0}
                            take={5}
                            dataGrid={documentsToExpire}

                            columnOne
                            titleRow1={t("digitalVaultOpereationalReportView.about.grid.title.1")}
                            cellColumnOne={DocumentsCellOne}
                            headerColumnOne={AllHeadersColumns}
                            widthColumnOne={'90px'}

                            columnTwo
                            titleRow2={t("digitalVaultOpereationalReportView.about.grid.title.2")}
                            cellColumnTwo={DocumentsCellTwo}
                            headerColumnTwo={AllHeadersColumns}
                            widthColumnTwo={'70px'}

                            columnThree
                            titleRow3={t("digitalVaultOpereationalReportView.about.grid.title.3")}
                            cellColumnThree={DocumentsCellThree}
                            headerColumnThree={AllHeadersColumns}
                            widthColumnThree={'60px'}

                            columnFour
                            titleRow4={t("digitalVaultOpereationalReportView.about.grid.title.4")}
                            cellColumnFour={DocumentsCellFour}
                            headerColumnFour={AllHeadersColumns}
                            widthColumnFour={'30px'}

                            columnFive
                            titleRow5={""}
                            headerColumnFiveClass={"digitalVaultOperationalReportView-col5"}
                            columnFiveStyleClass={"digitalVaultOperationalReportView-col5"}
                            iconOneActive
                            labelOneActions={t("digitalVaultOpereationalReportView.about.grid.title.btns.view.document")}
                            activeDialog1
                            mobileFunction
                            btnOpenDialog1={(dataItem) => setSelectedDocumentId(dataItem.id)}
                            widthColumnFive={widthColumnFive}

                            onSelectedItem={() => { }}
                            setNameComponentUser={() => { }}
                            setShowDetails={() => { }}
                        />
                    </div>
                </Grid>
                <Grid item sm={12} md={6}>
                    <div className='digitalVaultReportsView-card'>
                        <h4 className='digitalVaultReportsView-card-title expired'>{t("digitalVaultOpereationalReportView.expired")}</h4>
                        <GridSelectionHLPure
                            skip={0}
                            take={5}
                            dataGrid={expiredDocuments}

                            columnOne
                            titleRow1={t("digitalVaultOpereationalReportView.about.grid.2.title.1")}
                            headerColumnOne={AllHeadersColumns}
                            cellColumnOne={DocumentsCellOne}
                            widthColumnOne={'120px'}

                            columnTwo
                            titleRow2={t("digitalVaultOpereationalReportView.about.grid.2.title.2")}
                            headerColumnTwo={AllHeadersColumns}
                            cellColumnTwo={DocumentsCellTwo}
                            widthColumnTwo={'70px'}

                            columnThree
                            titleRow3={t("digitalVaultOpereationalReportView.about.grid.2.title.3")}
                            headerColumnThree={AllHeadersColumns}
                            cellColumnThree={DocumentsCellThree}
                            widthColumnThree={'50px'}

                            columnFive
                            titleRow5={""}
                            headerColumnFiveClass={"digitalVaultOperationalReportView-col5"}
                            columnFiveStyleClass={"digitalVaultOperationalReportView-col5"}
                            iconOneActive
                            labelOneActions={t("digitalVaultOpereationalReportView.about.grid.title.btns.view.document")}
                            activeDialog1
                            mobileFunction
                            btnOpenDialog1={(dataItem) => setSelectedDocumentId(dataItem.id)}
                            widthColumnFive={widthColumnFive}

                            onSelectedItem={() => { }}
                            setNameComponentUser={() => { }}
                            setShowDetails={() => { }}
                        />
                    </div>
                </Grid>
            </Grid>
            <DialogSystemGLPure
                showLoadingRequesting={modalStates.showLoadingRequesting}
                showCompletedRequesting={modalStates.showCompletedRequesting}
                showErrorRequesting={modalStates.showErrorRequesting}
                showWarningRequesting={modalStates.showWarningRequesting}
                message={modalStates.message}
                toggleLoadingRequesting={modalStates.toggleLoadingRequesting}
                toggleCompletedRequesting={modalStates.toggleCompletedRequesting}
                toggleErrorRequesting={modalStates.toggleErrorRequesting}
                toggleWarningRequesting={modalStates.toggleWarningRequesting}
            />
        </Container>
    )
}

export default DigitalVaultOpereationalReportView